import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Card, CardHeader, CardBody, Row, Col, Button, Input, Label, Form, FormGroup, Alert, FormFeedback } from 'reactstrap'
import { validationHelper, normalizeHelper } from '../../../../common/helpers'
import { messages } from '../../../../common/constants'
import { toast } from 'react-toastify'
import { createCategory, resetCreateCategory } from '../../../../store/category/actions'
import { MainLoader } from '../../../../components'

class CategoryAdd extends Component {

    constructor(props) {
        super(props)

        this.onSubmit = this.onSubmit.bind(this)
    }
    componentWillUnmount() {
        this.props.resetCreateCategory();
    }
    onSubmit(values) {
        this.props.createCategory(values, () => {
            toast.success('Categoría creada satisfactoriamente')
            this.props.history.push('/administration/categories')
        })
    }

    renderInputField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'


        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label className={labelClass} >{field.label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} invalid={hasError} type={field.type} />
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    render() {
        const { handleSubmit, loading, error } = this.props
        if (loading) {
            return <MainLoader />
        }
        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        Nueva Categoría
                    </CardHeader>
                    <CardBody>
                        {
                            error && (
                                <Alert color="danger">
                                    {error}
                                </Alert>
                            )
                        }
                        <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))} >
                            <Field name='name' label='Nombre *:' type='text' component={this.renderInputField} normalize={normalizeHelper.letterOnlyField()} />

                            <Row>
                                <Col className='mt-3'>
                                    <Button type='submit' disabled={loading} color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                                    <Button color='secondary' onClick={() => this.props.history.push('/administration/categories')} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

function validate(values) {
    const errors = {}

    if (validationHelper.stringIsNullOrEmpty(values.name)) {
        errors.name = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.lettersOnly(values.name)) {
        errors.name = messages.LETTERS_ONLY_FIELD
    }

    return errors
}

function mapStateToProps(state) {

    const { category, loading, error } = state.category.newCategory

    return {
        category,
        loading,
        error
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        createCategory,
        resetCreateCategory
    }, dispatch)
}

export default reduxForm({
    form: 'CategoryAddForm',
    touchOnBlur: false,
    validate
})(
    connect(mapStateToProps, mapDispatchToProps)(CategoryAdd)
)



// WEBPACK FOOTER //
// ./src/scenes/Administration/Category/CategoryAdd/CategoryAdd.js